import { Grid } from '@mui/material';
import { Form, Formik, FormikProps } from 'formik';
import React from 'react';
import { useSelector } from 'react-redux';
import { FormField } from '../../../../global/components/form-element/form-field';
import { PhoneField } from '../../../../global/components/form-element/phone-input';
import { FormWrapper } from '../../../../global/components/form-wrapper';
import { FormGroup } from '../../../../global/components/layout/form-group';
import { ContentSpacer } from '../../../../global/components/layout/generic-content-spacer';
import { PageHeader } from '../../../../global/components/layout/page-header';
import { YesNoOptions } from '../../../../global/constants/lists';
import { useApiResponseError } from '../../../../global/hooks/useApiError';
import { YesNoIndicators } from '../../../../global/models/api-model';
import { LabelSettingProps } from '../../../../global/models/epi-model';
import { TcsmStates } from '../../../../root/tcsm-model';
import { GetPointOfContactValidation, PointOfContactFormModel, PointOfContactPageModel } from '../mycpg-midyear/models/mycpg-mid-year-models';

interface Props {
    model: PointOfContactPageModel,
    onSubmitHandler: (pointOfContactFormValues: PointOfContactFormModel) => void;
    onCancelHandler: () => void;
}

export function PointOfContactForm(props: Props) {
    const { model, onSubmitHandler, onCancelHandler } = props;

    const labelSetting = useSelector<TcsmStates, LabelSettingProps>(state => state?.epiProps?.labelSettingState?.epiContent);

    const apiErrors = useApiResponseError();

    const initialValues: PointOfContactFormModel = {
        is_contact_person: YesNoIndicators.Yes,
        full_name_contact: '',
        your_contact_email: '',
        relationship_to_deceased: '',
        contact_email: '',
        your_contact_phone_formated: '',
        your_contact_phone_country_code: '',
        contact_phone_number_formated: '',
        contact_phone_country_code: '',
        dependent_type: model?.dependentType,
    };

    const validationSchema = GetPointOfContactValidation(labelSetting, model);

    function RenderYourContactPerson(formProps: FormikProps<PointOfContactFormModel>) {
        if (!(formProps.values.is_contact_person === YesNoIndicators.Yes)) return null;

        return <>
            <PhoneField
                label={model?.yourContactPhoneLabel}
                countryFieldName='your_contact_phone_country_code'
                phoneFieldName='your_contact_phone_formated'
                ext={false}
                formProps={formProps}
                required
            />
            <FormField
                name='your_contact_email'
                label={model?.yourContactEmailLabel}
                component='input'
                errors={formProps.errors}
                touched={formProps.touched}
                required
            />
        </>;
    }

    function RenderOtherContactPerson(formProps: FormikProps<PointOfContactFormModel>) {
        if (formProps.values.is_contact_person === YesNoIndicators.Yes) return null;

        return <>
            <FormField
                name='full_name_contact'
                label={model?.fullNameContactLabel}
                component='input'
                errors={formProps.errors}
                touched={formProps.touched}
                required
            />

            <FormField
                name='relationship_to_deceased'
                label={model?.relationshipToDeceasedLabel}
                component='input'
                errors={formProps.errors}
                touched={formProps.touched} />

            <PhoneField
                label={model?.contactPhoneLabel}
                countryFieldName='contact_phone_country_code'
                phoneFieldName='contact_phone_number_formated'
                ext={false}
                formProps={formProps}
                required
            />
            <FormField
                name='contact_email'
                label={model?.contactEmailLabel}
                component='input'
                errors={formProps.errors}
                touched={formProps.touched}
            />
        </>;
    }

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={(values: PointOfContactFormModel) => onSubmitHandler(values)}
            enableReinitialize
            initialErrors={apiErrors}
            validationSchema={validationSchema}
        >
            {(formProps: FormikProps<PointOfContactFormModel>) => (
                <>
                    <Form>
                        <Grid>
                            <FormWrapper
                                formikProps={formProps}
                                submitText={model?.continueButtonText}
                                cancelText={model?.cancelButtonText}
                                onCancel={onCancelHandler}                                
                                formKeys={Object.keys(initialValues)}>

                                <PageHeader
                                    headerText={model?.pageTitle}
                                    description={model?.pageDescription}
                                />
                                <ContentSpacer>
                                    <FormGroup>
                                        <FormField
                                            name='is_contact_person'
                                            label={model?.isContactPersonLabel}
                                            component='radioGroup'
                                            options={YesNoOptions}
                                            touched={formProps.touched}
                                            errors={formProps.errors}
                                            required
                                        />
                                        {RenderYourContactPerson(formProps)}
                                        {RenderOtherContactPerson(formProps)}
                                    </FormGroup>
                                </ContentSpacer>
                            </FormWrapper>
                        </Grid>
                    </Form>
                </>
            )}
        </Formik>
    );
}

PointOfContactForm.defaultProps = {
};

export default PointOfContactForm;